<script>
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "CommentCount",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.COUNTS_AND_SCORES,
    displayName: "Comment Count",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [BaseStoryCardElementMixin],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.comment, "default.display-icon": "hide" }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canCommentOnPosts",
    ]),
    shouldShowAction() {
      return this.editMode || this.canCommentOnPosts;
    },
    myValue() {
      return countToShow(this.entity.commentCount, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      return; // TODO
    },
  },
};
</script>
